module.exports = __webpack_public_path__ + "img/asm0001.asm.a23b51ab.jpg";